export default __webpack_public_path__ + "static/media/GR00043-live_illustration.f7289115.svg";